import { STATUS_LABELS } from "../data/js/listing-statuses";

const ListingStatus = ({ status }) => {
  return (
    <div className={`listing-status num-${status}`}>
      {STATUS_LABELS[status]}
    </div>
  );
};

export default ListingStatus;
